const resolveResponseText = (payload) =>
  payload?.beurteilung?.trim()
  || payload?.result?.trim()
  || payload?.choices?.[0]?.message?.content?.trim()
  || "";

const resolveApiErrorMessage = (payload) =>
  payload?.error?.message
  || payload?.error
  || "Unbekannter API-Fehler.";

const isRelativeEndpoint = (value) => String(value || "").startsWith("/");

const parseJsonSafe = async (response) => response.json().catch(() => ({}));

export const createAiService = ({ endpoint, openaiModel, anthropicModel, getAccessToken }) => {
  const requestAiText = async ({ provider, systemPrompt, context, maxTokens = 1200 }) => {
    const model = provider === "anthropic" ? anthropicModel : openaiModel;
    const accessToken = String(getAccessToken?.() || "").trim();
    const shouldAttachAuthHeader = isRelativeEndpoint(endpoint);
    const headers = { "Content-Type": "application/json" };
    if (accessToken && shouldAttachAuthHeader) {
      headers.Authorization = `Bearer ${accessToken}`;
    }

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 30_000);

    let response;
    try {
      response = await fetch(endpoint, {
        method: "POST",
        headers,
        signal: controller.signal,
        body: JSON.stringify({
          provider,
          model,
          max_tokens: maxTokens,
          system_prompt: systemPrompt,
          context,
        }),
      });
    } catch (err) {
      if (err.name === "AbortError") {
        throw new Error("Anfrage-Timeout: Der Server hat nicht rechtzeitig geantwortet.");
      }
      throw err;
    } finally {
      clearTimeout(timeoutId);
    }

    const payload = await parseJsonSafe(response);
    if (!response.ok) {
      throw new Error(resolveApiErrorMessage(payload));
    }

    return resolveResponseText(payload);
  };

  return {
    requestAiText,
  };
};
